import React from "react"
import FullRecoilDemo from "./FullAppDemo"
// import MysteryActivityDemo from "./MysteryActivityDemo"
// import SmartRouletteDemo from "./SmartRouletteDemo"
// import EnhancedRoulette from "./EnhancedRoulette"

const EventRoulette: React.FC = () => {
  return <FullRecoilDemo />
}

export default EventRoulette
